// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__bgXAh","item":"PaymentsMobile_item__1GA6Z","label":"PaymentsMobile_label__1c8t9","amount":"PaymentsMobile_amount__2SbHI"};